export function lessonDetailPath(id?: string | number): string {
    return `/portal/lesson/${id}`
}